import { z } from 'zod';

import { t } from '../services/translations/translation';

export const getAddressSchema = () =>
  z.object(
    {
      type: z
        .enum(['standard', 'trainstation', 'airport', 'company', 'favorite', 'favorite-home', 'favorite-work'])
        .optional(),
      formattedAddress: z
        .string()
        .trim()
        .min(1, { message: t('pwa.common.errors.required') }),
      name: z.string().nullable().optional(),
      lat: z.number().optional(),
      lng: z.number().optional(),
      placeId: z.string().optional(),
      terminal: z.string().optional(),
      driverText: z.string().optional(),
    },
    { message: t('pwa.common.errors.required') },
  );

export const TimeIntentOptionValue = z.enum(['DEPARTURE', 'ARRIVAL']);

export const TimeIntentDISchema = z.object({ type: z.literal('DI') });

export const TimeIntentDASchema = z.object({
  type: z.literal('DA'),
  intent: TimeIntentOptionValue,
  date: z.string(),
  time: z.string(),
  timestamp: z.number(),
});

export const TimeIntentSchema = z.union([TimeIntentDISchema, TimeIntentDASchema]);
